/** API route map: URLS.Controller.ClientAssessments */
export const ClientAssessments = {
      Name: 'ClientAssessment/',
      GetJobs: 'get-jobs',
      GetJobName: 'get-job-name',
      SearchJobs: 'search-jobs',
      GetForms: 'get-forms',
      SearchForms: 'search-forms',
      GetFormById: 'get-form',
      GetOnlyFormById: 'get-only-form',
      AddForm: 'add',
      AddSubmission: 'add-submission',
      UpdateForm: 'update',
      DeleteForm: 'delete-form',
      DeleteSection: 'delete-section',
      DeleteQuestion: 'delete-question',
      DeleteOption: 'delete-option',
      GetAssignedAssessmentStatus: 'get-assignment-status',
      UpdateAssignedAssessmentStatus: 'set-assignment-status',
      GetSubmission: 'get-submission',
      GetAssignedAssessment: 'get-assignedassessment',
};
